import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useScrollOnMount from "src/hooks/App/useScrollOnMount";
import PagesHistory from "../shared/minicomponents/pagehistory/PagesHistory";
import AccountMenuSection from "./accountmenu-section/AccountMenuSection";

import s from "./AccountPage.module.scss";
import EditProfileForm from "./editprofile-form/EditProfileForm";

const AccountPage = () => {
  const { loginInfo } = useSelector((state) => state.user);
  const { t } = useTranslation();

  useScrollOnMount(0);

  return (
    <>
      <Helmet>
        <title>Profile</title>
        <meta
          name="description"
          content="Update your personal information easily on Exclusive. Manage your account details, shipping addresses, and preferences for a personalized shopping experience."
        />
      </Helmet>

      <div className="container">
        <main className={s.accountPage} id="account-page">
          <div className={s.wrapper}>
            <PagesHistory history={["/", t("nav.profile")]} />

            <p className={s.welcomeMessage}>
              {t("common.welcome")}
              {"! "}
              <Link to="/profile">{loginInfo.username}</Link>
            </p>
          </div>

          <div className={s.accountPageContent}>
            <AccountMenuSection />
            <EditProfileForm />
          </div>
        </main>
      </div>
    </>
  );
};
export default AccountPage;
